import {
  INGREDIENT_RECIPES_PAGE_REQUEST,
  INGREDIENT_RECIPES_RECIPES_REQUEST,
  INGREDIENT_RECIPES_UPDATE_LIST_RECIPE,
  INGREDIENT_RECIPES_SET_OUTLETS,
  INGREDIENT_RECIPES_SET_RECIPES,
  INGREDIENT_RECIPES_OPEN_RIGHT_COLUMN,
  INGREDIENT_RECIPES_CLOSE_RIGHT_COLUMN,
  INGREDIENT_RECIPES_SUBMIT_FORM_CREATE,
  INGREDIENT_RECIPES_ON_CLICK_ROW,
  INGREDIENT_RECIPES_SET_RECIPES_DETAIL,
  INGREDIENT_RECIPES_EXPORT_RECIPES,
  INGREDIENT_RECIPES_ON_CLICK_DONE,
  INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES,
  INGREDIENT_RECIPES_SET_CURRENT_PAGE,
  INGREDIENT_RECIPES_SET_TOTAL_PAGE,
  INGREDIENT_RECIPES_SET_TOTAL_COUNT,
  INGREDIENT_RECIPES_ON_CHANGE_OUTLET_IDS,
  INGREDIENT_RECIPES_SHOW_ADD_ITEMS_MODAL,
  INGREDIENT_RECIPES_HIDE_ADD_ITEMS_MODAL,
  INGREDIENT_RECIPES_ON_CLICK_ADD_ITEMS,
  INGREDIENT_RECIPES_ADD_ITEMS_CONFIRM_ADD_ITEMS,
  INGREDIENT_RECIPES_ADD_ITEMS_SET_ITEMS,
  INGREDIENT_RECIPES_ADD_ITEMS_SHOW_LOADING,
  INGREDIENT_RECIPES_ADD_ITEMS_HIDE_LOADING,
  INGREDIENT_RECIPES_ADD_ITEMS_VARIANT_ON_CHANGE_ITEMS,
  INGREDIENT_RECIPES_RECIPES_DETAIL_PAGE,
  INGREDIENT_RECIPES_RECIPES_FORM_ON_CHANGE_OUTLET,
  INGREDIENT_RECIPES_RECIPES_FORM_ON_CLICK_CANCEL,
  INGREDIENT_RECIPES_SHOW_CONFIRM_SUBMIT_MODAL,
  INGREDIENT_RECIPES_HIDE_CONFIRM_SUBMIT_MODAL,
  INGREDIENT_RECIPES_CONFIRM_SUBMIT,
  INGREDIENT_RECIPES_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT,
  INGREDIENT_RECIPES_SET_FILTER_ITEM,
  INGREDIENT_RECIPES_SET_FILTER_STATE,
  INGREDIENT_RECIPES_UNSET_FILTER_STATE,
  INGREDIENT_RECIPES_SET_ITEMS_DROPDOWN,
  INGREDIENT_RECIPES_SET_ITEM_VARIANT,
  INGREDIENT_RECIPES_GET_INGREDIENT_REQUEST,
  INGREDIENT_RECIPES_SET_INGREDIENT_REQUEST,
  INGREDIENT_RECIPES_ADD_INGREDIENTS_CANCEL_ADD_INGREDIENTS,
  INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_SEARCH_INGREDIENTS,
  INGREDIENT_RECIPES_ADD_INGREDIENTS_HIDE_ALREADY_ADDED_ALERT,
  INGREDIENT_RECIPES_ADD_INGREDIENTS_GET_INGREDIENTS_REQUEST,
  INGREDIENT_RECIPES_ADD_INGREDIENT_SET_INGREDIENT,
  INGREDIENT_RECIPES_ADD_RECIPES_HIDE_ALREADY_ADDED_ALERT,
  INGREDIENT_RECIPES_ADD_RECIPES_SET_KEYWORD,
  INGREDIENT_RECIPES_ADD_ITEMS_ON_CHANGE_ITEMS,
  INGREDIENT_RECIPES_ADD_INGREDIENT_DETAIL_RECIPES,
  INGREDIENT_RECIPES_SHOW_DELETE_MODAL,
  INGREDIENT_RECIPES_HIDE_DELETE_MODAL,
  INGREDIENT_RECIPES_DELETE_ITEM,
  INGREDIENT_RECIPES_SAVE_RECIPES,
  INGREDIENT_RECIPES_SAVE_RECIPES_ALL_OUTLET,
  INGREDIENT_RECIPES_UPDATE_RECIPES,
  INGREDIENT_RECIPES_UPDATE_RECIPES_ALL_OUTLET,
  INGREDIENT_RECIPES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL,
  INGREDIENT_RECIPES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL,
  INGREDIENT_RECIPES_SET_RECIPES_FORM,
  INGREDIENT_RECIPES_SET_CREATED_OUTLETS,
  INGREDIENT_RECIPES_SET_INGREDIENT_BY_VARIANT_ID,
  INGREDIENT_RECIPES_UNSET_INGREDIENT_BY_VARIANT_ID,
  INGREDIENT_RECIPES_IS_SUBMITTING_FORM,
  INGREDIENT_RECIPES_EXPORT_DONE,
  INGREDIENT_RECIPES_EXPORT_START,
  INGREDIENT_RECIPES_EXPORT_FAILED,
  INGREDIENT_RECIPES_SET_ASYNCJOBID,
  INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES_SHOW_MODAL,
  INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES_HIDE_MODAL,
  INGREDIENT_RECIPES_NEXT_STEP_FORM_MODAL,
  INGREDIENT_RECIPES_BACK_STEP_FORM_MODAL,
  INGREDIENT_RECIPES_IMPORT_TYPE,
  INGREDIENT_RECIPES_DROP_FILE_CREATE_RECIPES_FORM,
  INGREDIENT_RECIPES_SAVE_FILE,
  INGREDIENT_RECIPES_UPLOAD_FILE_FAILED,
  INGREDIENT_RECIPES_UPDATE_INCORRECT,
  INGREDIENT_RECIPES_LOADING_UPLOAD,
  INGREDIENT_RECIPES_RESET_LOADING,
  INGREDIENT_RECIPES_UPLOAD_FILE_SUCCESS,
  INGREDIENT_RECIPES_SAVE_IMPORT_RECIPE,
  INGREDIENT_RECIPES_RESET_MODAL_IMPORT_RECIPE,
  INGREDIENT_RECIPES_ERROR_VALIDATION_CSV,
  INGREDIENT_RECIPES_OPEN_CREATE_RECIPES_MODAL,
  INGREDIENT_RECIPES_SET_REPONSE_FAILED_IMPORT_RECIPE,
  INGREDIENT_RECIPES_START_DOWNLOAD_ERROR_LIST_IMPORT_RECIPE,
} from './constants';

export function pageRequest() {
  return { type: INGREDIENT_RECIPES_PAGE_REQUEST, payload: {} };
}

export function recipesRequest(params, previousRecipes) {
  return {
    type: INGREDIENT_RECIPES_RECIPES_REQUEST,
    payload: { params, previousRecipes },
  };
}

export function updateListRecipe(params, previousRecipes) {
  return {
    type: INGREDIENT_RECIPES_UPDATE_LIST_RECIPE,
    payload: { params, previousRecipes },
  };
}

export function setOutlets(outlets) {
  return { type: INGREDIENT_RECIPES_SET_OUTLETS, payload: { outlets } };
}

export function setRecipes(recipes) {
  return { type: INGREDIENT_RECIPES_SET_RECIPES, payload: { recipes } };
}

export function openRightColumn() {
  return { type: INGREDIENT_RECIPES_OPEN_RIGHT_COLUMN, payload: {} };
}

export function showCreateRecipesModal(outletId) {
  return {
    type: INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES_SHOW_MODAL,
    payload: { outletId },
  };
}

export function setOpenCreateRecipesModal() {
  return { type: INGREDIENT_RECIPES_OPEN_CREATE_RECIPES_MODAL, payload: {} };
}

export function closeRightColumn() {
  return { type: INGREDIENT_RECIPES_CLOSE_RIGHT_COLUMN, payload: {} };
}

export function submitFormCreate(data, previousRecipes) {
  return {
    type: INGREDIENT_RECIPES_SUBMIT_FORM_CREATE,
    payload: { data, previousRecipes },
  };
}

export function onClickRow(recipes) {
  return { type: INGREDIENT_RECIPES_ON_CLICK_ROW, payload: { recipes } };
}
export function setRecipesDetail(recipes) {
  return { type: INGREDIENT_RECIPES_SET_RECIPES_DETAIL, payload: { recipes } };
}

export function exportRecipes(params, filename, outletId, outletName, email) {
  return {
    type: INGREDIENT_RECIPES_EXPORT_RECIPES,
    payload: { params, filename, outletId, outletName, email },
  };
}

export function closeCreateRecipesModal() {
  return {
    type: INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES_HIDE_MODAL,
    payload: {},
  };
}

export function resetModalImportRecipe() {
  return { type: INGREDIENT_RECIPES_RESET_MODAL_IMPORT_RECIPE, payload: {} };
}

export function errorValidationUploadCsv(message) {
  return { type: INGREDIENT_RECIPES_ERROR_VALIDATION_CSV, payload: message };
}

export function nextStepCreateRecipes() {
  return { type: INGREDIENT_RECIPES_NEXT_STEP_FORM_MODAL, payload: {} };
}

export function backStepCreateRecipes() {
  return { type: INGREDIENT_RECIPES_BACK_STEP_FORM_MODAL, payload: {} };
}

export function onClickImportType(type) {
  return { type: INGREDIENT_RECIPES_IMPORT_TYPE, payload: type };
}

export function onDropFileCreateRecipes() {
  return {
    type: INGREDIENT_RECIPES_DROP_FILE_CREATE_RECIPES_FORM,
    payload: {},
  };
}

export function saveFileRecipes(image) {
  return { type: INGREDIENT_RECIPES_SAVE_FILE, payload: image };
}

export function responseUploadFailed(message, outletId) {
  return {
    type: INGREDIENT_RECIPES_UPLOAD_FILE_FAILED,
    payload: { message, outletId },
  };
}

export function setMessageResponseFailedImportRecipe(messages) {
  return {
    type: INGREDIENT_RECIPES_SET_REPONSE_FAILED_IMPORT_RECIPE,
    payload: messages,
  };
}

export function startDownloadErrorListImportRecipe(params, outletId) {
  return {
    type: INGREDIENT_RECIPES_START_DOWNLOAD_ERROR_LIST_IMPORT_RECIPE,
    payload: { params, outletId },
  };
}

export function updateIncorrect() {
  return { type: INGREDIENT_RECIPES_UPDATE_INCORRECT, payload: {} };
}

export function loadingUpload() {
  return { type: INGREDIENT_RECIPES_LOADING_UPLOAD, payload: {} };
}

export function resetLoadingUpload() {
  return { type: INGREDIENT_RECIPES_RESET_LOADING, payload: {} };
}

export function importRecipe(params, body, outletId) {
  return {
    type: INGREDIENT_RECIPES_SAVE_IMPORT_RECIPE,
    payload: { params, file: body, outletId },
  };
}

export function successUpload() {
  return { type: INGREDIENT_RECIPES_UPLOAD_FILE_SUCCESS, payload: {} };
}

export function onClickDone() {
  return { type: INGREDIENT_RECIPES_ON_CLICK_DONE, payload: {} };
}

export function onClickCreateRecipes(outletId) {
  return {
    type: INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES,
    payload: { outletId },
  };
}

export function recipesFormOnChangeOutlet(outletId) {
  return {
    type: INGREDIENT_RECIPES_RECIPES_FORM_ON_CHANGE_OUTLET,
    payload: { outletId },
  };
}

export function setCurrentPage(page) {
  return { type: INGREDIENT_RECIPES_SET_CURRENT_PAGE, payload: { page } };
}

export function setTotalPage(page) {
  return { type: INGREDIENT_RECIPES_SET_TOTAL_PAGE, payload: { page } };
}

export function setTotalCount(totalCount) {
  return { type: INGREDIENT_RECIPES_SET_TOTAL_COUNT, payload: { totalCount } };
}

export function onChangeOutletIds(outletIds, startDate, endDate, namespace) {
  return {
    type: INGREDIENT_RECIPES_ON_CHANGE_OUTLET_IDS,
    payload: { outletIds, startDate, endDate, namespace },
  };
}

export function showAddItemsModal() {
  return { type: INGREDIENT_RECIPES_SHOW_ADD_ITEMS_MODAL, payload: {} };
}

export function hideAddIngredientsModal() {
  return { type: INGREDIENT_RECIPES_HIDE_ADD_ITEMS_MODAL, payload: {} };
}

export function onClickAddIngredients() {
  return { type: INGREDIENT_RECIPES_ON_CLICK_ADD_ITEMS, payload: {} };
}

export function setFilterRecipes(keyword) {
  return { type: INGREDIENT_RECIPES_SET_FILTER_ITEM, payload: { keyword } };
}

export function addIngredientsConfirmAddItems(
  addIngredientsFormValues,
  recipes
) {
  return {
    type: INGREDIENT_RECIPES_ADD_ITEMS_CONFIRM_ADD_ITEMS,
    payload: { addIngredientsFormValues, recipes },
  };
}

export function addIngredientsSetItems(ingredients) {
  return {
    type: INGREDIENT_RECIPES_ADD_ITEMS_SET_ITEMS,
    payload: { ingredients },
  };
}

export function addIngredientsShowLoading() {
  return { type: INGREDIENT_RECIPES_ADD_ITEMS_SHOW_LOADING, payload: {} };
}

export function addIngredientsHideLoading() {
  return { type: INGREDIENT_RECIPES_ADD_ITEMS_HIDE_LOADING, payload: {} };
}

export function setRecipesDetailPage(page) {
  return { type: INGREDIENT_RECIPES_RECIPES_DETAIL_PAGE, payload: { page } };
}

export function recipesFormOnClickCancel() {
  return { type: INGREDIENT_RECIPES_RECIPES_FORM_ON_CLICK_CANCEL, payload: {} };
}

export function showConfirmSubmitModal() {
  return { type: INGREDIENT_RECIPES_SHOW_CONFIRM_SUBMIT_MODAL, payload: {} };
}

export function hideConfirmSubmitModal() {
  return { type: INGREDIENT_RECIPES_HIDE_CONFIRM_SUBMIT_MODAL, payload: {} };
}

export function confirmSubmit(values, namespace, date) {
  return {
    type: INGREDIENT_RECIPES_CONFIRM_SUBMIT,
    payload: { values, namespace, date },
  };
}

export function setFilterState(keyword) {
  return { type: INGREDIENT_RECIPES_SET_FILTER_STATE, payload: { keyword } };
}

export function addIngredientsShowAlreadyAddedAlert() {
  return {
    type: INGREDIENT_RECIPES_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT,
    payload: {},
  };
}

export function unSetFilterState() {
  return { type: INGREDIENT_RECIPES_UNSET_FILTER_STATE };
}

export function setItemDropdown(itemsDropdowns) {
  return {
    type: INGREDIENT_RECIPES_SET_ITEMS_DROPDOWN,
    payload: { itemsDropdowns },
  };
}

export function setItemVariant(itemVariant) {
  return {
    type: INGREDIENT_RECIPES_SET_ITEM_VARIANT,
    payload: { itemVariant },
  };
}

export function addIngredientsGetingredientRequest(params) {
  return {
    type: INGREDIENT_RECIPES_GET_INGREDIENT_REQUEST,
    payload: { params },
  };
}

export function setIngredientGetingredientRequest(params) {
  return {
    type: INGREDIENT_RECIPES_SET_INGREDIENT_REQUEST,
    payload: { params },
  };
}

export function addItemVariantOnChangeItems(selectedItem, recipesForm) {
  return {
    type: INGREDIENT_RECIPES_ADD_ITEMS_VARIANT_ON_CHANGE_ITEMS,
    payload: { selectedItem, recipesForm },
  };
}

// Modal
export function addIngredientsOnChangeSelectModal(ingredient, recipesForm) {
  return {
    type: INGREDIENT_RECIPES_ADD_ITEMS_ON_CHANGE_ITEMS,
    payload: { ingredient, recipesForm },
  };
}

export function addIngredientsOnSearchModal(keyword) {
  return {
    type: INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_SEARCH_INGREDIENTS,
    payload: { keyword },
  };
}

export function cancelAddIngredientsModal() {
  return {
    type: INGREDIENT_RECIPES_ADD_INGREDIENTS_CANCEL_ADD_INGREDIENTS,
    payload: {},
  };
}

export function addIngredientsHideAlreadyAddedAlertModal() {
  return {
    type: INGREDIENT_RECIPES_ADD_INGREDIENTS_HIDE_ALREADY_ADDED_ALERT,
    payload: {},
  };
}

export function addIngredientsGetIngredientsRequestModal(params) {
  return {
    type: INGREDIENT_RECIPES_ADD_INGREDIENTS_GET_INGREDIENTS_REQUEST,
    payload: { params },
  };
}

export function addIngredientsSetIngredient(ingredient) {
  return {
    type: INGREDIENT_RECIPES_ADD_INGREDIENT_SET_INGREDIENT,
    payload: { ingredient },
  };
}

export function addIngredientsHideAlreadyAddedAlert() {
  return {
    type: INGREDIENT_RECIPES_ADD_RECIPES_HIDE_ALREADY_ADDED_ALERT,
    payload: {},
  };
}

export function addIngredientsSetKeyword(keyword) {
  return {
    type: INGREDIENT_RECIPES_ADD_RECIPES_SET_KEYWORD,
    payload: { keyword },
  };
}

export function addIngredientRecipesDetail(values, recipesForm) {
  return {
    type: INGREDIENT_RECIPES_ADD_INGREDIENT_DETAIL_RECIPES,
    payload: { values, recipesForm },
  };
}

export function showDeleteModal() {
  return { type: INGREDIENT_RECIPES_SHOW_DELETE_MODAL, payload: {} };
}

export function hideDeleteModal() {
  return { type: INGREDIENT_RECIPES_HIDE_DELETE_MODAL, payload: {} };
}

export function deleteRecipes(recipe, previousRecipes) {
  return {
    type: INGREDIENT_RECIPES_DELETE_ITEM,
    payload: { recipe, previousRecipes },
  };
}

export function onSaveRecipes(values, previousRecipes) {
  return {
    type: INGREDIENT_RECIPES_SAVE_RECIPES,
    payload: { recipe: values, previousRecipes },
  };
}

export function onSaveRecipesAllOutlet(values, previousRecipes) {
  return {
    type: INGREDIENT_RECIPES_SAVE_RECIPES_ALL_OUTLET,
    payload: { recipe: values, previousRecipes },
  };
}

export function onUpdateRecipes(values, previousRecipes) {
  return {
    type: INGREDIENT_RECIPES_UPDATE_RECIPES,
    payload: { recipe: values, previousRecipes },
  };
}

export function onUpdateRecipesAllOutlet(values, previousRecipes) {
  return {
    type: INGREDIENT_RECIPES_UPDATE_RECIPES_ALL_OUTLET,
    payload: { recipe: values, previousRecipes },
  };
}

export function setRecipesForm(recipesForm) {
  return {
    type: INGREDIENT_RECIPES_SET_RECIPES_FORM,
    payload: { recipesForm },
  };
}

export function showSaveToAllOutletsModal() {
  return {
    type: INGREDIENT_RECIPES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL,
    payload: {},
  };
}

export function hideSaveToAllOutletsModal() {
  return {
    type: INGREDIENT_RECIPES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL,
    payload: {},
  };
}

export function setCreatedOutlets(createdOutlets) {
  return {
    type: INGREDIENT_RECIPES_SET_CREATED_OUTLETS,
    payload: { createdOutlets },
  };
}

export function setIngredientByItemVariant(
  itemVariant,
  recipesForm,
  selectedVariant
) {
  return {
    type: INGREDIENT_RECIPES_SET_INGREDIENT_BY_VARIANT_ID,
    payload: { itemVariant, recipesForm, selectedVariant },
  };
}

export function unSetIngredientByItemVariant() {
  return {
    type: INGREDIENT_RECIPES_UNSET_INGREDIENT_BY_VARIANT_ID,
    payload: {},
  };
}

export function isSubmittingForm(isSubmittingForm) {
  return {
    type: INGREDIENT_RECIPES_IS_SUBMITTING_FORM,
    payload: { isSubmittingForm },
  };
}

export function startExportRecipe() {
  return { type: INGREDIENT_RECIPES_EXPORT_START, payload: {} };
}

export function doneExportRecipe() {
  return { type: INGREDIENT_RECIPES_EXPORT_DONE, payload: {} };
}

export function errorExportRecipe() {
  return { type: INGREDIENT_RECIPES_EXPORT_FAILED, payload: {} };
}

export function setIdAsyncJob(idAsyncJob) {
  return { type: INGREDIENT_RECIPES_SET_ASYNCJOBID, payload: { idAsyncJob } };
}
